<template>
  <div id="listWidget" class="mb-5">
    <!-- <h4 class="mb-3">커튼 관리</h4> -->  
    <!-- <p>
      방 목록을 선택하면 온도조절기 관리 화면으로 이동할 수 있습니다.
    </p> -->

    <!-- <hr class="mb-4" v-if="curtainDevices.length > 0" /> -->

    <div class="row" v-for="item in curtainDevices" :key="item._id">
      <div class="col-md-6 mb-2">
        <div class="list-group card-item" style="border-radius: 1.2rem;">
          <ListGroupItem>
            <div class="flex-1 text-break" v-touch:hold="onTouchHold">
              <div style="font-size: 0.9rem">{{ item.group.name }}: {{ item.name }}</div>
            </div>
            <div @click.stop="() => onDeleteClick(item)" style="text-align: right; min-width: 40px;">
              <i class="fa-regular fa-trash-can"></i>
            </div>
          </ListGroupItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, getCurrentInstance, computed, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute ,onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import PopDialog from '@/common/components/popup/PopDialog.vue';
import useModal from '@/common/hooks/useModal';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import { Template } from '@/common/constants';
import useMqttControl from '@/common/hooks/useMqttControl';
import Axios, { DeviceApi, CtrlApi } from '@/api';

const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const router = useRouter();
const route = useRoute();
const store = useStore();
const zone = computed(() => store.getters['home/getCurrentZone']);
const groups = computed(() => zone.value?.groups || []);
const curtainDevices = computed(() => {
  let devices = [];
  groups.value.forEach(group => {
    const resultDevices = group.devices.filter(device => device.type == 3 || device.type == 5 || device.type == 6)
      .map(device => ({ group, ...device }));
    devices = [...devices, ...resultDevices];
  });
  return devices;
});

const requestDeleteDevice = async (device) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.delete(
        DeviceApi.DELETE_DEVICE.replace(':id', device._id),
      );
      if (result.resultCode === '0000') {
        store.commit('home/deleteDevice', {
          zoneId: parseInt(zone.value._id),
          groupId: parseInt(device.group._id),
          deviceId: device._id,
        });
        resolve(true);
        return;
      }
      reject("장치 삭제에 실패했습니다.");
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};

const onDeleteClick = (device) => {
  emitter.emit('showPopConfirm', {
    description: "정말 삭제하시겠습니까?",
    okCallback: async () => {
      try {
        await requestDeleteDevice(device);

        emitter.emit('showPopAlert', {
          description: "커튼이 삭제되었습니다.",
        });
      } catch (e) {
        emitter.emit('showPopAlert', {
          description: e,
        });
      }
    }
  });
}

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'커튼 관리',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});    
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true,isShowRightHome:false});  
})
</script>
